var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["./foreign-key-buttons.html"] = require( "./foreign-key-buttons.html" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"buttons\">\n    ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("./foreign-key-buttons.html", false, "enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html", null, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
callback(null,t_1);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_4,t_2) {
if(t_4) { cb(t_4); return; }
callback(null,t_2);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html
// module id = ./enso_cms/static/enso-cms/nunjucks-templates/widgets/foreign-key-widget.html
// module chunks = main